import React from 'react';
import styled from 'styled-components';
import { useStaticQuery, graphql } from 'gatsby';
import { Utils, Container } from '@hiro-ui/bootstrap';

export interface BannerProps {
  main?: string;
  title?: string;
  subtitle?: string;
  large?: boolean;
  secondary?: boolean;
}

const TeaserDiv = styled(Container)<BannerProps>`
  ${Utils.below('md')} {
    display: none !important;
  }

  position: absolute;
  bottom: 0;
  top: 0;

  & > img {
    position: absolute;
    height: 350px;
    right: 0;
    top: ${({ large, secondary }) => (large || secondary ? 30 : 10)}px;
    box-sizing: border-box;
  }
`;

const TitleDiv = styled.div<BannerProps>`
  ${Utils.below('md')} {
    flex: 1 1 100%;
  }

  display: flex;
  flex: 0 1 50%;
  flex-flow: column nowrap;
  justify-content: center;
  align-self: ${({ secondary }) => (secondary ? 'flex-start' : 'auto')};

  & > h1 {
    font-size: 2em;
    z-index: 1;
  }

  & > h2 {
    z-index: 1;
    width: 100%;
  }
`;

const BannerDiv = styled.div<BannerProps>`
  position: relative;
  background-color: ${({ theme }) => theme.colors.primary.default};
  height: ${({ large, secondary }) => (large || secondary ? 400 : 150)}px;
  display: flex;
  margin-bottom: 2em;

  color: white;

  & > ${Container} {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: start;
  }
`;

export const Banner: React.FC<BannerProps> = ({ main, subtitle, large, secondary }) => {
  const { file } = useStaticQuery(graphql`
    query MyQuery {
      file(relativePath: { eq: "Teaser.svg" }) {
        name
        publicURL
        relativePath
      }
    }
  `);

  return (
    <BannerDiv large={large} secondary={secondary}>
      <Container>
        <TitleDiv secondary={secondary}>
          {main && <h1>{main}</h1>}
          {subtitle && <span>{subtitle}</span>}
        </TitleDiv>
        <TeaserDiv large={large}>
          <img src={file.publicURL} alt="logo" />
        </TeaserDiv>
      </Container>
    </BannerDiv>
  );
};
